import { Button, ButtonType, BackButton, DialogHeader } from '@checkmarx/cx-ui';
import classNames from 'classnames';
import Dialog from 'material-ui/Dialog';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { UserEditDialogForm } from '../../../services/enums/users';
import ToastrLevelsEnum from '../../../services/enums/toastrLevelsEnum';
import InviteUserTab from '../addEditUser/inviteUserTab';
import styles from './style.scss';
import ToastrService from '../../../services/ui/toastrService';

@inject('translationsStore', 'inviteUserStore', 'usersStore') @observer
export default class InviteUsersDialogContainer extends Component {

    t = this.props.translationsStore;
    
    componentWillMount() {

        this.props.inviteUserStore.setIsAddUserError(false);
        this.props.inviteUserStore.setAddUserErrorMessage('');
    }

    handleSuccessfulSaveOperation() {

        this.props.usersStore.getAllUsers();
        this.props.closeAddUserModal();
        
        var level = ToastrLevelsEnum.SUCCESS;
        var message = this.t.translate('USER_CREATED_SUCCESS_MESSAGE');
        ToastrService.triggerToastr({level, message});

        this.props.inviteUserStore.reset();
    }
    
    handleSubmitForm = (e) => {
        e.preventDefault();

        this.props.inviteUserStore.setAddUserErrorMessage('');
        
            const isValid = this.props.inviteUserStore.validateInviteForm();

            if (isValid === false) {
                this.props.inviteUserStore.setIsAddUserError(true);
                const validationErrorMessage = this.props.translationsStore.translate('SEE_ERRORS_BELOW');
                this.props.inviteUserStore.setAddUserErrorMessage(validationErrorMessage);
                return;
            }


            this.props.inviteUserStore.inviteUsers().then(() => {
            
                this.handleSuccessfulSaveOperation();
            });
    }

    render() {

        let title, content, link, className = '';

        if (this.props.mode === undefined || this.props.mode === UserEditDialogForm.add) {
        
            title = this.t.translate('INVITE_USER');
            content = <form onSubmit={this.handleSubmitForm}>
                        <InviteUserTab />
                    </form>;
        }
        
        const actions = <div className='user-form-buttons-container'>
                            <span className='portal-blank-button' onClick={this.props.closeAddUserModal} data-cy='cancel-user-button'>
                                {this.props.translationsStore.translate('CANCEL')}
                            </span>
                            <Button
                                type='submit'
                                onClick={this.handleSubmitForm}
                                inProgress={this.props.inviteUserStore.creatingUser || this.props.inviteUserStore.updatingUser}
                                text={this.props.translationsStore.translate('SAVE')}>
                            </Button>
                        </div>;

        return (
            <Dialog 
               className={classNames(styles.ldapAddGroupsHeader)}
               open={this.props.show}
               repositionOnUpdate={false}
               actions={actions}
               actionsContainerStyle={{padding: 0}}
               customContentStyle={{
                   width: '100%',
                   maxWidth: 'none',
                   height: '60vh'
                 }}
            >
               <div className={classNames(styles.dialogMainWrapper)}>
                   <div className={classNames(styles.dialogImportLdapUserMainHeaderWrapper)}>
                       {link}
                       <DialogHeader
                           title={title}
                           displayCloseButton
                           closeClick={this.props.closeAddUserModal}
                           className={className}
                       />
                   </div>
                   <div >
                       {content}
                   </div>
               </div>
            </Dialog>
        );
    }
}